import { StorageConstants } from "./storageConstants";

const cookiePrefix = (): string => {
    return '';
}
/**
 * get all cookies and set into an array
 * @returns {{}}
 */
const getCookies = (): any => {
    const pairs = document.cookie.split(';');
    let cookies = {};
    for (let i = 0; i < pairs.length; i++) {
        const pair = pairs[i].split('=');
        cookies[pair[0].trim()] = unescape(pair[1]);
    }
    return cookies;
}
/**
 * store a cookie using key and value
 * @param {string} key
 * @param {string} value
 */
const setCookie = (key: string, value: string) => {
    deleteCookie(key);
    document.cookie = cookiePrefix() + key + '=' + value + '; path=/';
}
/**
 * get cookie value by key
 * @param {string} key
 * @returns {string}
 */
const getCookie = (key: string): string => {
    const cookies = getCookies();
    const cookieKey = cookiePrefix() + key;
    return cookies?.[cookieKey] ?? '';
}
/**
 * delete a cookie by key
 * @param {string} key
 */
const deleteCookie = (key: string): void => {
    document.cookie =
        cookiePrefix() +
        key +
        '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;';
}

export const clearAuthStorage = ():void => {
    localStorage.removeItem(StorageConstants.LOGIN_TOKEN);
    localStorage.removeItem(StorageConstants.USED_ID);
    localStorage.removeItem(StorageConstants.LOGIN_TIME);
}

export const AuthStorage = {
    cookiePrefix, getCookie, deleteCookie, setCookie, getCookies
}
